
class AuthController {

    constructor($state, djangoAuth) {
        this.username = '';
        this.password = '';
        this.$state = $state;
        this.djangoAuth = djangoAuth;
        this.djangoAuth.logout();
    }

    login() {
        this.djangoAuth.login(this.username, this.password)
            .then((data) => {
                console.log(data);
                this.$state.go('dashboard');
            }, (data) => {
                // error case
                this.errors = data;
            });
    }


}

AuthController.$inject = ['$state', 'djangoAuth'];


export {AuthController};



// WEBPACK FOOTER //
// ./app/components/auth/auth.controller.js